<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width d-flex align-items-center">
        <div class="col-sm-12 col-md-5">
          <span class="toolbar-title">{{ labelTitle }}</span>
        </div>
        <div
          class="col-sm-12 col-md-7 d-flex justify-content-end"
          style="gap: 0.5rem"
        >
          <button
            mat-flat-button
            color="primary"
            (click)="
              openLink(
                'https://docs.google.com/forms/d/e/1FAIpQLScG1uYt_8pLHCFYv_5eT_JBHMW55eX4zEFQb3YZUrEzDwis9A/viewform'
              )
            "
            matTooltip="New ASCC user request form"
            *ngIf="requestUserPrivilege"
          >
            <mat-icon>person_add</mat-icon>
          </button>
          <button
            mat-flat-button
            color="accent"
            (click)="enableMove = !enableMove"
            matTooltip="Modify Order"
            *ngIf="createCategoryPrivilege"
          >
            <mat-icon>swipe_vertical</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      #sidenav
      class="d-print-none"
      mode="side"
      opened="true"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item class="show-overflow">
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
          <mat-hint *ngIf="isExpanded || isShowing" align="start"
            >Search results indicated with
            <mat-icon class="green" style="font-size: 18px"
              >saved_search</mat-icon
            >icon
          </mat-hint>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list class="full-height">
        <mat-list-item class="full-height d-flex flex-column">
          <apl-category-v2-list
            *ngIf="(isExpanded || isShowing) && !loading"
            class="full-height full-width"
            [aplCategories]="
              createCategoryPrivilege || aplCategoryEdit || aplCategoryApproval
                ? aplCategoriesFiltered
                : nonPendingCategories
            "
            [aplContainers]="aplContainersFiltered"
          >
          </apl-category-v2-list>
        </mat-list-item>
      </mat-nav-list>
      <!-- <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="createCategoryPrivilege"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New Category</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list> -->
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <mat-accordion multi="true">
            <mat-expansion-panel
              class="apl-container-expansion-panel"
              [ngClass]="{ 'not-expanded': !container.open }"
              *ngFor="let container of aplContainersFiltered"
              [expanded]="container.open"
              (afterExpand)="container.open = true"
              (afterCollapse)="container.open = false"
              id="{{ container.id }}"
            >
              <mat-expansion-panel-header>
                <div
                  class="row full-width d-flex justify-content-between align-items-center w-100"
                >
                  <!-- Left Side: Title -->
                  <div class="col-auto pr-0">
                    <h4 class="mb-0">
                      {{ container.name }}
                    </h4>
                  </div>

                  <!-- Right Side: Add Category Button -->
                  <div class="col-auto pl-0">
                    <mat-icon
                      *ngIf="container.hasMatch"
                      class="green"
                      title="Filter match found"
                      >saved_search
                    </mat-icon>
                    <button
                      mat-icon-button
                      *ngIf="createCategoryPrivilege"
                      color="primary"
                      aria-label="Add Category"
                      title="Add Category"
                      (click)="
                        addCategory(container.id); $event.stopPropagation()
                      "
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-expansion-panel-header>

              <mat-expansion-panel-body class="pl-0">
                <apl-category-v2-categories
                  [aplContainers]="aplContainersFiltered"
                  [containerCategories]="container.aplCategories"
                  [enableMove]="enableMove"
                  [filter]="filter"
                  (categoriesChanged)="onCategoriesChanged($event)"
                ></apl-category-v2-categories>
              </mat-expansion-panel-body>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading" [message]="loadingMessage">
  <!-- </overlay-loading> -->
</div>
